import moment from "moment/moment";
import React from "react";
import {useDesktop} from "./useDesktop";

export const useDays = (dateValue) => {
    const isDesktop = useDesktop();
    const days = Array.from({length: isDesktop ? 7 : 5}, (v, i) => {
        const day = moment(dateValue).add(i, "days")
        return ({
            tooltip: `${day.format("dddd")} ${day.format("DD/MM/YYYY")}`,
            day: day.format("dd"),
            date: day.format("DD.MM"),
            weekend: day.day() === 6 || day.day() === 0,
        })
    });
    return isDesktop ? days : [...days, {empty: true}];
}
